var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect, useMemo, useState } from "react";
import { selectBallotStyleByElectionId } from "../store/ballotStyles/ballotStylesSlice";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { Box } from "@mui/material";
import { PageLimit, Icon, IconButton, theme, Dialog } from "@sequentech/ui-essentials";
import { check_voting_error_dialog_bool, check_voting_not_allowed_next_bool, stringToHtml, isUndefined, translateFromPresentation, EElectionEventContestEncryptionPolicy, } from "@sequentech/ui-core";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { faCircleQuestion, faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import { Link as RouterLink, redirect, useNavigate, useParams, useSubmit } from "react-router-dom";
import { selectBallotSelectionByElectionId, setBallotSelection, resetBallotSelection, } from "../store/ballotSelections/ballotSelectionsSlice";
import { clearIsVoted, setIsVoted } from "../store/extra/extraSlice";
import { provideBallotService } from "../services/BallotService";
import { setAuditableBallot } from "../store/auditableBallots/auditableBallotsSlice";
import { Question } from "../components/Question/Question";
import { CircularProgress } from "@mui/material";
import { selectElectionById } from "../store/elections/electionsSlice";
import { useRootBackLink } from "../hooks/root-back-link";
import { VotingPortalError, VotingPortalErrorType } from "../services/VotingPortalError";
import Stepper from "../components/Stepper";
import { AuthContext } from "../providers/AuthContextProvider";
import { canVoteSomeElection } from "../store/castVotes/castVotesSlice";
import { sortContestList } from "@sequentech/ui-core";
var StyledLink = styled(RouterLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: auto 0;\n    text-decoration: none;\n"], ["\n    margin: auto 0;\n    text-decoration: none;\n"])));
var StyledTitle = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 36px;\n    justify-content: center;\n"], ["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 36px;\n    justify-content: center;\n"])));
var ActionsContainer = styled(Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 20px;\n    margin-top: 10px;\n    gap: 2px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 20px;\n    margin-top: 10px;\n    gap: 2px;\n"])));
var StyledButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display flex;\n    padding: 5px;\n\n    span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding: 5px;\n    }\n"], ["\n    display flex;\n    padding: 5px;\n\n    span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding: 5px;\n    }\n"])));
var ActionButtons = function (_a) {
    var handleNext = _a.handleNext, handlePrev = _a.handlePrev, handleClearCustom = _a.handleClearCustom, pageIndex = _a.pageIndex, disableNext = _a.disableNext;
    var t = useTranslation().t;
    var backLink = useRootBackLink();
    var electionId = useParams().electionId;
    var ballotStyle = useAppSelector(selectBallotStyleByElectionId(String(electionId)));
    var dispatch = useAppDispatch();
    function handleClear() {
        if (ballotStyle) {
            dispatch(resetBallotSelection({
                ballotStyle: ballotStyle,
                force: true,
            }));
            dispatch(clearIsVoted());
        }
    }
    return (_jsxs(_Fragment, { children: [_jsx(StyledButton, __assign({ sx: {
                    display: { sm: "none" },
                    width: "100%",
                }, variant: "secondary", onClick: function () { return (handleClearCustom ? handleClearCustom() : handleClear()); } }, { children: _jsx(Box, { children: t("votingScreen.clearButton") }) })), _jsxs(ActionsContainer, { children: [_jsx(StyledLink, __assign({ to: pageIndex && pageIndex > 0 ? "" : backLink, sx: { margin: "auto 0", width: { xs: "100%", sm: "200px" } }, onClick: function () { return handlePrev(); } }, { children: _jsxs(StyledButton, __assign({ sx: { width: { xs: "100%", sm: "200px" } } }, { children: [_jsx(Icon, { icon: faAngleLeft, size: "sm" }), _jsx(Box, { children: t("votingScreen.backButton") })] })) })), _jsx(StyledButton, __assign({ sx: {
                            display: { xs: "none", sm: "block" },
                            width: { xs: "100%", sm: "200px" },
                        }, variant: "secondary", onClick: function () { return (handleClearCustom ? handleClearCustom() : handleClear()); } }, { children: _jsx(Box, { children: t("votingScreen.clearButton") }) })), _jsxs(StyledButton, __assign({ className: "next-button", sx: { width: { xs: "100%", sm: "200px" } }, onClick: function () { return handleNext(); }, disabled: disableNext }, { children: [_jsx(Box, { children: t("votingScreen.reviewButton") }), _jsx(Icon, { icon: faAngleRight, size: "sm" })] }))] })] }));
};
var ContestPagination = function (_a) {
    var _b, _c;
    var ballotStyle = _a.ballotStyle, contests = _a.contests, onSetDisableNext = _a.onSetDisableNext, onSetDecodedContests = _a.onSetDecodedContests, encryptAndReview = _a.encryptAndReview, disableNextButton = _a.disableNextButton;
    var dispatch = useAppDispatch();
    var contestsOrderType = (_b = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_presentation) === null || _b === void 0 ? void 0 : _b.contests_order;
    var _d = useState(0), pageIndex = _d[0], setPageIndex = _d[1];
    var sortedContests = sortContestList(contests[pageIndex], contestsOrderType);
    var ballotSelectionState = useAppSelector(selectBallotSelectionByElectionId(ballotStyle.election_id));
    var _e = provideBallotService(), interpretContestSelection = _e.interpretContestSelection, interpretMultiContestSelection = _e.interpretMultiContestSelection;
    var isMultiContest = ((_c = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_event_presentation) === null || _c === void 0 ? void 0 : _c.contest_encryption_policy) ==
        EElectionEventContestEncryptionPolicy.MULTIPLE_CONTESTS;
    var errorSelectionState = useMemo(function () {
        if (!ballotSelectionState) {
            return [];
        }
        var err = isMultiContest
            ? interpretMultiContestSelection(ballotSelectionState, ballotStyle.ballot_eml)
            : interpretContestSelection(ballotSelectionState, ballotStyle.ballot_eml);
        return err;
    }, [ballotSelectionState, isMultiContest, ballotStyle.ballot_eml]);
    var handleNext = function () {
        if (pageIndex === contests.length - 1) {
            encryptAndReview();
        }
        else {
            setPageIndex(pageIndex + 1);
        }
    };
    var handlePrev = function () {
        if (pageIndex > 0) {
            setPageIndex(pageIndex - 1);
        }
        else {
            dispatch(clearIsVoted());
        }
    };
    function handleClear() {
        if (ballotStyle) {
            contests[pageIndex].forEach(function (contest) {
                dispatch(resetBallotSelection({
                    ballotStyle: ballotStyle,
                    force: true,
                    contestId: contest.id,
                }));
            });
            if (pageIndex === 0)
                dispatch(clearIsVoted());
        }
    }
    return (_jsxs(_Fragment, { children: [sortedContests &&
                sortedContests.map(function (contest, index) { return (_jsx(Box, __assign({ className: "contest-".concat(index) }, { children: _jsx(Question, { ballotStyle: ballotStyle, question: contest, isReview: false, setDisableNext: function () { return onSetDisableNext(contest.id); }, setDecodedContests: onSetDecodedContests(contest.id), errorSelectionState: errorSelectionState }) }), contest.id)); }), _jsx(ActionButtons, { handleNext: handleNext, handlePrev: handlePrev, handleClearCustom: handleClear, pageIndex: pageIndex, disableNext: disableNextButton(sortedContests) && contests.length !== 1 })] }));
};
var VotingScreen = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var _j = useTranslation(), t = _j.t, i18n = _j.i18n;
    var logout = useContext(AuthContext).logout;
    var canVote = useAppSelector(canVoteSomeElection());
    var electionId = useParams().electionId;
    var _k = useState({}), disableNext = _k[0], setDisableNext = _k[1];
    var _l = useState({}), decodedContests = _l[0], setDecodedContests = _l[1];
    var _m = useState(false), openBallotHelp = _m[0], setOpenBallotHelp = _m[1];
    var _o = useState(false), openNotVoted = _o[0], setOpenNonVoted = _o[1];
    var _p = useState(false), hasInvalidErrors = _p[0], setHasInvalidErrors = _p[1];
    var _q = useState([]), contestsPerPage = _q[0], setContestsPerPage = _q[1];
    var _r = provideBallotService(), encryptBallotSelection = _r.encryptBallotSelection, encryptMultiBallotSelection = _r.encryptMultiBallotSelection, decodeAuditableBallot = _r.decodeAuditableBallot, decodeAuditableMultiBallot = _r.decodeAuditableMultiBallot;
    var election = useAppSelector(selectElectionById(String(electionId)));
    var ballotStyle = useAppSelector(selectBallotStyleByElectionId(String(electionId)));
    var defaultLanguageCode = (_c = (_b = (_a = election === null || election === void 0 ? void 0 : election.presentation) === null || _a === void 0 ? void 0 : _a.language_conf) === null || _b === void 0 ? void 0 : _b.default_language_code) !== null && _c !== void 0 ? _c : (_e = (_d = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_event_presentation) === null || _d === void 0 ? void 0 : _d.language_conf) === null || _e === void 0 ? void 0 : _e.default_language_code;
    var selectionState = useAppSelector(selectBallotSelectionByElectionId((_f = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.election_id) !== null && _f !== void 0 ? _f : ""));
    var backLink = useRootBackLink();
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var submit = useSubmit();
    var onSetDisableNext = function (id) { return function (value) {
        var _a;
        setDisableNext(__assign(__assign({}, disableNext), (_a = {}, _a[id] = value, _a)));
    }; };
    var onSetDecodedContests = function (id) { return function (value) {
        setDecodedContests(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[id] = value, _a)));
        });
    }; };
    // if true, when the user clicks next, there will be a dialog
    // that doesn't allow to continue and forces the user to fix the issues
    var disableNextButton = function (contests) {
        if (contests === void 0) { contests = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.contests; }
        return check_voting_not_allowed_next_bool(contests, decodedContests);
    };
    // if true, when the user click next, there will be a dialog that prompts
    // the user to confirm before going to the next screen
    var showNextDialog = function () {
        return check_voting_error_dialog_bool(ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.contests, decodedContests);
    };
    var encryptAndReview = function () {
        if (isUndefined(selectionState) || !ballotStyle) {
            return;
        }
        else if (showNextDialog() || disableNextButton()) {
            setOpenNonVoted(true);
            var newHasInvalidErrors = Object.values(decodedContests).some(function (a) { return (a === null || a === void 0 ? void 0 : a.invalid_errors.length) > 0; });
            setHasInvalidErrors(newHasInvalidErrors);
        }
        else {
            finallyEncryptAndReview();
        }
        dispatch(setIsVoted(electionId));
    };
    var finallyEncryptAndReview = function () {
        var _a, _b;
        if (isUndefined(selectionState) || !ballotStyle) {
            return;
        }
        try {
            var isMultiContest = ((_a = ballotStyle.ballot_eml.election_event_presentation) === null || _a === void 0 ? void 0 : _a.contest_encryption_policy) ==
                EElectionEventContestEncryptionPolicy.MULTIPLE_CONTESTS;
            var auditableBallot = isMultiContest
                ? encryptMultiBallotSelection(selectionState, ballotStyle.ballot_eml)
                : encryptBallotSelection(selectionState, ballotStyle.ballot_eml);
            dispatch(setAuditableBallot({
                electionId: (_b = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.election_id) !== null && _b !== void 0 ? _b : "",
                auditableBallot: auditableBallot,
            }));
            var decodedSelectionState = isMultiContest
                ? decodeAuditableMultiBallot(auditableBallot)
                : decodeAuditableBallot(auditableBallot);
            if (null !== decodedSelectionState) {
                dispatch(setBallotSelection({
                    ballotStyle: ballotStyle,
                    ballotSelection: decodedSelectionState,
                }));
            }
            submit(null, { method: "post" });
        }
        catch (error) {
            submit({ error: VotingPortalErrorType.UNABLE_TO_CAST_BALLOT }, { method: "post" });
        }
    };
    useEffect(function () {
        if (!election || !ballotStyle) {
            navigate(backLink);
        }
        else if (!selectionState || !canVote) {
            logout();
        }
    }, [navigate, backLink, election, ballotStyle, selectionState, canVote, logout]);
    useEffect(function () {
        var _a, _b, _c;
        var minMaxGlobal = false;
        var contestsPages = new Map();
        var contests = __spreadArray([], ((_a = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.contests) !== null && _a !== void 0 ? _a : []), true).sort(function (a, b) { var _a, _b, _c, _d; return ((_b = (_a = a.presentation) === null || _a === void 0 ? void 0 : _a.sort_order) !== null && _b !== void 0 ? _b : Infinity) - ((_d = (_c = b.presentation) === null || _c === void 0 ? void 0 : _c.sort_order) !== null && _d !== void 0 ? _d : Infinity); });
        var _loop_1 = function (contest) {
            var countVotes = 0;
            var selection = selectionState === null || selectionState === void 0 ? void 0 : selectionState.find(function (s) { return s.contest_id === contest.id; });
            for (var _e = 0, _f = (_b = selection === null || selection === void 0 ? void 0 : selection.choices) !== null && _b !== void 0 ? _b : []; _e < _f.length; _e++) {
                var choice = _f[_e];
                if (choice.selected > -1) {
                    countVotes += choice.selected + 1;
                }
            }
            var outOfRange = countVotes < contest.min_votes || countVotes > contest.max_votes;
            minMaxGlobal = minMaxGlobal || outOfRange;
            // Calculate contests pagination using the pagination_policy string identifier
            var contestPageName = ((_c = contest.presentation) === null || _c === void 0 ? void 0 : _c.pagination_policy) || "";
            if (!contestsPages.has(contestPageName)) {
                contestsPages.set(contestPageName, []);
            }
            contestsPages.get(contestPageName).push(contest);
        };
        for (var _i = 0, _d = contests !== null && contests !== void 0 ? contests : []; _i < _d.length; _i++) {
            var contest = _d[_i];
            _loop_1(contest);
        }
        var contestsAsArrays = Array.from(contestsPages.values());
        setContestsPerPage(contestsAsArrays);
        setDisableNext(function (state) { return (__assign(__assign({}, state), { minmax_global: minMaxGlobal })); });
    }, [selectionState, ballotStyle]);
    if (!ballotStyle || !election) {
        return _jsx(CircularProgress, {});
    }
    var warnAllowContinue = function (value) {
        setOpenNonVoted(false);
        if (value) {
            finallyEncryptAndReview();
        }
    };
    return (_jsxs(PageLimit, __assign({ maxWidth: "lg", className: "voting-screen screen" }, { children: [_jsx(Box, __assign({ marginTop: "48px", className: "stepper-box" }, { children: _jsx(Stepper, { selected: 1 }) })), _jsxs(StyledTitle, __assign({ variant: "h4", className: "title-container" }, { children: [_jsx(Box, __assign({ className: "selected-election-title" }, { children: (_g = translateFromPresentation(election, "name", i18n.language, {
                            defaultLanguageCode: defaultLanguageCode,
                        })) !== null && _g !== void 0 ? _g : "-" })), _jsx(IconButton, { className: "title-question", icon: faCircleQuestion, sx: { fontSize: "unset", lineHeight: "unset", paddingBottom: "2px" }, fontSize: "16px", onClick: function () { return setOpenBallotHelp(true); } }), _jsx(Dialog, __assign({ handleClose: function () { return setOpenBallotHelp(false); }, open: openBallotHelp, title: t("votingScreen.ballotHelpDialog.title"), ok: t("votingScreen.ballotHelpDialog.ok"), variant: "info" }, { children: stringToHtml(t("votingScreen.ballotHelpDialog.content")) }))] })), election.description ? (_jsx(Typography, __assign({ className: "description", variant: "body2", sx: { color: theme.palette.customGrey.main } }, { children: stringToHtml((_h = translateFromPresentation(election, "description", i18n.language, {
                    defaultLanguageCode: defaultLanguageCode,
                })) !== null && _h !== void 0 ? _h : "-") }))) : null, _jsx(ContestPagination, { ballotStyle: ballotStyle, contests: contestsPerPage, onSetDisableNext: onSetDisableNext, onSetDecodedContests: onSetDecodedContests, encryptAndReview: encryptAndReview, disableNextButton: disableNextButton }), disableNextButton() ? (_jsx(Dialog, __assign({ handleClose: function (value) { return setOpenNonVoted(false); }, open: openNotVoted, title: t("votingScreen.nonVotedDialog.title"), ok: t("votingScreen.nonVotedDialog.ok"), variant: "softwarning" }, { children: stringToHtml(t("votingScreen.nonVotedDialog.content")) }))) : (_jsx(Dialog, __assign({ handleClose: function (value) { return warnAllowContinue(value); }, open: openNotVoted, title: t(hasInvalidErrors
                    ? "votingScreen.nonVotedDialog.title"
                    : "votingScreen.warningDialog.title"), ok: t(hasInvalidErrors
                    ? "votingScreen.nonVotedDialog.continue"
                    : "votingScreen.warningDialog.continue"), cancel: t(hasInvalidErrors
                    ? "votingScreen.nonVotedDialog.cancel"
                    : "votingScreen.warningDialog.cancel"), variant: "action" }, { children: stringToHtml(t(hasInvalidErrors
                    ? "votingScreen.nonVotedDialog.content"
                    : "votingScreen.warningDialog.content")) })))] })));
};
export default VotingScreen;
export function action(_a) {
    var request = _a.request;
    return __awaiter(this, void 0, void 0, function () {
        var data, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, request.formData()];
                case 1:
                    data = _b.sent();
                    error = data.get("error");
                    if (error) {
                        throw new VotingPortalError(VotingPortalErrorType[error]);
                    }
                    return [2 /*return*/, redirect("../review")];
            }
        });
    });
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
